import { render, staticRenderFns } from "./ChartAdvert.vue?vue&type=template&id=2ed5f260&scoped=true&"
import script from "./ChartAdvert.vue?vue&type=script&lang=js&"
export * from "./ChartAdvert.vue?vue&type=script&lang=js&"
import style0 from "./ChartAdvert.vue?vue&type=style&index=0&id=2ed5f260&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed5f260",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAlert,VCard,VCardText,VCol,VProgressCircular,VRow})
